<template>
	<div class="scrollable only-y reset-password-page align-vertical">
		<div class="form-wrapper align-vertical-middle">
			<div class="form-box card-base card-shadow--extraLarge">
				<el-row :gutter="30" class="no-p no-m">
					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="tab-invert bg-primary p-30">
						<img class="image-logo" src="@/assets/images/logo.png" alt="logo"/>
					</el-col>
					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="p-30">
						<h1 class="mt-0 mb-10">{{ $t("reset_password.reset_password") }}</h1>
						<p class="pb-30">{{ $t("reset_password.desc") }}</p>
						<float-label class="styled">
							<input type="password" v-model="form.password" placeholder="New Password">
						</float-label>
                        <float-label class="styled">
							<input type="password" v-model="form.conf_password" placeholder="Confirm Password">
						</float-label>

						<div class="flex text-center center pt-30 pb-20">			
							<el-button :loading="btnLoading" round @click="update_password" class="send-btn tada animated">
								{{ $t("reset_password.update_password") }}
							</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const NodeRSA = require('node-rsa')
const key = new NodeRSA({b:512});
const pub = key.importKey(config.privateKey, 'pkcs1-public-pem');

export default {
	name: 'ResetPassword',
	data() {
		return {
			form: {
				conf_password: '',
				password: '',
			},
			btnLoading: false
		}
	},
	methods: {
		reset() {			
			
		},
		async update_password() {			
			if(this.form.password.length < 8){
				this.$swal({
					title: this.$t('error'),
					text: this.$t(`reset_password.invalid_length`),
					type: 'warning',
				})
				return
			}
            this.btnLoading = true
            if(this.form.conf_password != "" && this.form.password != ""){
                if(this.form.conf_password == this.form.password){
                    await api({
                        method: 'post',
                        url: config.baseApi + 'auth/reset-password/' + this.$route.params.verify_code,
                        data: { password: pub.encrypt(this.form.password, 'base64'), conf_password: pub.encrypt(this.form.conf_password, 'base64') }
                    })
                    .then(result => {                        
                        this.$swal({
                            title: this.$t('success'),
                            text: this.$t(`reset_password.${result.data.message}`),
                            type: 'success',
                        })
                        .then(confirm => {
                            this.$router.push('/login')
                        })
                    })
                    .catch(error => {				
                        this.$swal({
                            title: this.$t('error'),
                            text: this.$t(`error_text`),
                            type: 'warning',
                        })
                    })
                } else{
                    this.$swal({
                        title: this.$t('error'),
                        text: this.$t(`reset_password.password_not_match`),
                        type: 'warning',
                    })
                }
                
            } else{
                this.$swal({
                    title: this.$t('error'),
                    text: this.$t(`reset_password.invalid_parameter`),
                    type: 'warning',
                })
            }			
			this.btnLoading = false
        },
        async check_code(){
            await api({
                method: 'get',
                url: config.baseApi + 'auth/check-reset-token/' + this.$route.params.verify_code,                
            })
            .then(result => {                
                if(result.data.ec == 200){

                } else {
                    this.$router.push('/forgot-password')
                }                
            })
            .catch(error => {
                this.$router.push('/forgot-password')
            })
        }
    },
    async beforeMount(){
        this.check_code()
    }
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables';

.reset-password-page {
	background: rgb(74,197,197);
	background: linear-gradient(53deg, rgba(74,197,197,1) 0%, rgba(36,147,147,1) 100%);
	margin-left: -30px;
	margin-right: -30px;

	.form-wrapper {
		width: 100%;
	}
	
	.form-box {
		width: 100%;
		max-width: 400px;
		// padding: 30px;
		box-sizing: border-box;
		margin: 20px auto;

		a {
			font-size: 14px;
			color: $text-color-accent;
			text-decoration: none;
			font-weight: 500;
		}

		.image-logo {
			width: 200px;
			// margin: 0px auto;
			// margin-bottom: 30px;
			display: block;
		}

		.send-btn {
			width: 200px;
			background-color: $text-color-accent;
			color: white;

			&:hover {
				opacity: .9;
			}
		}
	}
}

@media (max-width: 768px) {
	.layout-container .container .view.reset-password-page {
		margin-left: -5px;
		margin-right: -5px;
		max-width: calc(100% + 10px);
	}
}
</style>

<style lang="scss" scoped>
.el-col {
	padding-left: 30px !important;
	padding-right: 30px !important;
}
.tab-invert{
	height: 100%;
}
.white-text {
	color: white;
}
</style>
